var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('com-header',{attrs:{"className":"lecto-header-contain","compID":_vm.$route.params.id,"activeKey":"flxx"}}),_c('iframe',{style:({ height: '100vh' }),attrs:{"src":`${_vm.LectoWeb}/full/company/${_vm.$route.params.id}?source=engineer_client`,"id":"lectoIframe","frameborder":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }